import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const EditPaymentPlanModal = ({ show, handleClose, location, handleSave }) => {

    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (location) {

            setName(location.name || '');

        }
    }, [location]);

    const handleSaveClick = () => {
        setLoading(true);
        const updatedLocation = {
            ...location,
            name

        };
        api.put(`/location/${updatedLocation.id}`, updatedLocation).then(response => { toast.success("Location Updated Successfully!") }).catch(error => { console.log(error); toast.error(error) });
        handleSave(updatedLocation);
        setLoading(false);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Location</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Name */}
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSaveClick} disabled={loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPaymentPlanModal;
